export enum JobState {
    Failed = -1,
    AwaitingCompletion = 0,
    Completed = 1,
}

export interface Job {
    readonly id: string;
    readonly state: JobState;
}